import Alpine from 'alpinejs';
import Splide from '../../Helper/NeosSplide';
import {Video} from '@splidejs/splide-extension-video';
import {AutoScroll} from '@splidejs/splide-extension-auto-scroll';
window.splides = [];

Alpine.data('slider', (initSliderOnMobile) => ({
    init() {
        if (!initSliderOnMobile && window.innerWidth < 1024) {
            return;
        }
        const slides = this.$root.querySelectorAll('.splide__slide');
        const slidesCount = Array.from(slides).length;
        if (slidesCount === 0) {
            console.error('Could not initialize slider with zero slide(s)', this.$root);
            return;
        }
        slides[slidesCount - 1].classList.add('slide--is-last');
        const splide = new Splide(this.$root);
        window.splides.push(splide);

        splide.on('mounted', function () {
            splide.refresh();
        });

        let isAutoScroll = !!JSON.parse(this.$root.dataset.splide).autoScroll;
        let plugins = { Video };
        if (isAutoScroll) {
            plugins = { Video, AutoScroll };
        }

        splide.on('mounted', function () {
            splide.Components.Elements.slides[0].classList.add('is-active-slide');
        });

        // fix active class assigment
        splide.on('move', function () {
            let currentIndex = splide.Components.Controller.getIndex();
            splide.Components.Elements.slides.forEach((el, index) => {
                if (index === currentIndex) {
                    el.classList.remove('is-prev-slide');
                    el.classList.remove('is-next-slide');
                    el.classList.add('is-active-slide');
                }
                if (index < currentIndex) {
                    el.classList.remove('is-active-slide');
                    el.classList.remove('is-next-slide');
                    el.classList.add('is-prev-slide');
                }
                if (index > currentIndex) {
                    el.classList.remove('is-active-slide');
                    el.classList.remove('is-prev-slide');
                    el.classList.add('is-next-slide');
                }
            });
        });

        // custom arrows
        const arrows = document.querySelectorAll(`[data-slider-id="${splide.root.id}"]`);
        if (arrows.length) {
            Array.from(arrows).forEach(function (el) {
                let prev = el.querySelector('.splide__arrow--prev');
                let next = el.querySelector('.splide__arrow--next');

                prev.addEventListener('click', () => {
                    splide.go('-1');
                });

                next.addEventListener('click', () => {
                    splide.go('+1');
                });
            });
        }

        // sync two sliders is option provided
        let syncId = splide.root.dataset.sync;
        if (syncId) {
            splide.sync(window.splides.filter((el) => el.root.id === syncId)[0]);
        }

        // Support videos and disable the play button in the backend
        splide.mount(plugins);
        const inNeosBackend = window.name === 'neos-content-main';
        splide.Components.Video.disable(inNeosBackend);
        const maxIndex = splide.length - 1;
        splide.on('autoplay:playing', (rate) => {
            // Go to the first slide after the last slide
            if (rate === 1 && maxIndex === splide.index) {
                splide.go(0);
            }
        });
    },
}));
